import styled from '@emotion/styled';
import media from 'utils/media';
import searchIcon from 'assets/icons/search.svg';

export const GoogleSearchBoxInput = styled.div`
  display: block;
  width: 80%;
  min-width: 250px;
  height: 40px;
  border-bottom: 2px solid #000;
  margin: 0 auto;
  margin-bottom: 22px;
  position: relative;

  ${media.greaterThan.md} {
    width: 100%;
    height: 44px;
    margin-bottom: 12px;
  }

  input {
    padding: 0 40px 0 10px;
    font-size: 16px;
    outline: none;
    text-overflow: ellipsis;
    box-sizing: border-box;
    border: none;
    height: 100%;
    width: 100%;
  }
`;
export const Submit = styled.button`
  position: absolute;
  right: 0;
  bottom: 0;
  border: none;
  background: none;
  width: 40px;
  height: 100%;
  background-image: url(${searchIcon});
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: center 14px;
`;
